import { Reveal, Overline } from "@/components/motion";

const words = [
  {
    quote:
      "I have known Alex to be a person who can take a messy, “all over the place” idea and line it up so it actually makes sense. Instead of overcomplicating things, Alex is good at explaining the “why” and the “how” in a way that feels natural. I often walk away from a conversation with him feeling like I finally have a clearer handle on things.",
    name: "Jays",
    role: "Father to 2 girls, trader",
  },
  {
    quote:
      "Alex did a great job facilitating the sessions. He kept the participants engaged, shared practical insights and communicated with clarity and confidence, which made the sessions enjoyable and easy to follow. His presentation style and delivery kept the group's attention very naturally.",
    name: "Maxine",
    role: "Real Estate Agent",
  },
  {
    quote:
      "Alex is someone who is able to connect different pieces together and find a pattern or the “why” behind things. Talking with him, he usually offers a different perspective on a topic or an issue, which is very helpful to finding solutions and piecing things together.",
    name: "Joseph",
    role: "Lead Software Developer",
  },
];

export default function Testimonials({ dark = false }) {
  return (
    <section
      data-testid="testimonials-section"
      className={`border-t ${dark ? "border-paper/15 bg-ink text-paper" : "border-line bg-sand/40"}`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
        <Reveal>
          <Overline className={dark ? "text-paper/50" : ""}>Kind Words</Overline>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl tracking-tight leading-tight mt-6 max-w-3xl">
            From people Alex has{" "}
            <span className={`italic ${dark ? "text-clay" : "text-moss"}`}>walked with.</span>
          </h2>
        </Reveal>
        <div className={`mt-14 grid md:grid-cols-3 gap-px border ${dark ? "bg-paper/15 border-paper/15" : "bg-line border-line"}`}>
          {words.map((w, i) => (
            <Reveal key={w.name} delay={i * 0.1} className={dark ? "bg-ink" : "bg-paper"}>
              <figure
                data-testid={`testimonial-${i + 1}`}
                className="p-8 md:p-10 h-full flex flex-col"
              >
                <span className={`font-serif text-5xl leading-none ${dark ? "text-clay" : "text-clay/70"}`}>
                  &ldquo;
                </span>
                <blockquote className={`mt-4 font-serif text-lg md:text-xl leading-relaxed tracking-tight ${dark ? "text-paper/85" : "text-ink/80"}`}>
                  {w.quote}
                </blockquote>
                <figcaption className="mt-8 pt-6 border-t border-dashed border-current/20 mt-auto">
                  <p className={`text-sm font-medium tracking-wide ${dark ? "text-paper" : "text-ink"}`}>
                    {w.name}
                  </p>
                  <p className={`text-xs uppercase tracking-[0.2em] mt-1 ${dark ? "text-paper/50" : "text-stone"}`}>
                    {w.role}
                  </p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
